import { createReducer } from '../utils/reducers'
import {
  PROMO_CODE_VALIDATE_REQUESTED,
  PROMO_CODE_VALIDATE_RECIEVED,
  PROMO_CODE_VALIDATE_FAILED,
  PROMO_CODE_VALIDATE_CLEAR
} from '../utils/constants'

const initialState = {
  isValidating: false,
  isValid: null,
  checkedCode: null
}

const PromoCodeReducer = (state = initialState, action) => {
  return createReducer(state, action, {
    [PROMO_CODE_VALIDATE_REQUESTED]: (state, action) => ({
      ...state, isValidating: true, isValid: null, checkedCode: action.code
    }),
    [PROMO_CODE_VALIDATE_RECIEVED]: (state, action) => ({
      ...state, isValidating: false, isValid: action.valid
    }),
    [PROMO_CODE_VALIDATE_FAILED]: (state) => ({
      ...state, isValidating: false, isValid: null
    }),
    [PROMO_CODE_VALIDATE_CLEAR]: () => ({ ...initialState })
  })
}

export const getPromoValidation = (globalState) => globalState['promo_codes']

export default PromoCodeReducer
